export default __webpack_public_path__ + "static/media/svg3.0623716b.svg";